import React, { useEffect, useState } from 'react';
import { XIcon, BellIcon, UserPlusIcon, MusicIcon, HeadphonesIcon } from 'lucide-react';
interface NotificationsPopupProps {
  onClose: () => void;
}
export const NotificationsPopup = ({
  onClose
}: NotificationsPopupProps) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center" data-id="element-454">
        <div className="bg-[#282828] rounded-lg w-full max-w-sm mx-4 overflow-hidden" data-id="element-455">
          <div className="p-4 flex items-center justify-between border-b border-white/10" data-id="element-456">
            <h2 className="font-bold text-lg" data-id="element-457">Notifications</h2>
            <button onClick={onClose} className="p-1.5 hover:bg-white/10 rounded-full transition-colors" data-id="element-458">
              <XIcon className="w-5 h-5" data-id="element-459" />
            </button>
          </div>
          <div className="max-h-[60vh] overflow-y-auto" data-id="element-460">
            <NotificationItem icon={<UserPlusIcon className="w-5 h-5 text-white" data-id="element-462" />} title="New follower" message="John Smith started following you" time="2h ago" color="bg-blue-500" data-id="element-461" />
            <NotificationItem icon={<MusicIcon className="w-5 h-5 text-white" data-id="element-464" />} title="New release" message="The Weeknd just released a new album" time="1d ago" color="bg-green-500" data-id="element-463" />
            <NotificationItem icon={<HeadphonesIcon className="w-5 h-5 text-white" data-id="element-466" />} title="Playlist update" message="Your Release Radar has been updated" time="2d ago" color="bg-purple-500" data-id="element-465" />
            <NotificationItem icon={<BellIcon className="w-5 h-5 text-white" data-id="element-468" />} title="Spotify announcement" message="New feature: Movies now available on Spotify" time="3d ago" color="bg-red-500" data-id="element-467" />
            <div className="p-4 text-center" data-id="element-469">
              <button className="text-sm text-green-500 hover:text-green-400 transition-colors" data-id="element-470">
                View all notifications
              </button>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="fixed top-16 right-8 z-50" data-id="element-471">
      <div className="bg-[#282828] rounded-lg shadow-xl w-80 overflow-hidden" data-id="element-472">
        <div className="p-4 flex items-center justify-between border-b border-white/10" data-id="element-473">
          <h2 className="font-bold text-lg" data-id="element-474">Notifications</h2>
          <button onClick={onClose} className="p-1.5 hover:bg-white/10 rounded-full transition-colors" data-id="element-475">
            <XIcon className="w-5 h-5" data-id="element-476" />
          </button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto" data-id="element-477">
          <NotificationItem icon={<UserPlusIcon className="w-5 h-5 text-white" data-id="element-479" />} title="New follower" message="John Smith started following you" time="2h ago" color="bg-blue-500" data-id="element-478" />
          <NotificationItem icon={<MusicIcon className="w-5 h-5 text-white" data-id="element-481" />} title="New release" message="The Weeknd just released a new album" time="1d ago" color="bg-green-500" data-id="element-480" />
          <NotificationItem icon={<HeadphonesIcon className="w-5 h-5 text-white" data-id="element-483" />} title="Playlist update" message="Your Release Radar has been updated" time="2d ago" color="bg-purple-500" data-id="element-482" />
          <NotificationItem icon={<BellIcon className="w-5 h-5 text-white" data-id="element-485" />} title="Spotify announcement" message="New feature: Movies now available on Spotify" time="3d ago" color="bg-red-500" data-id="element-484" />
          <div className="p-4 text-center" data-id="element-486">
            <button className="text-sm text-green-500 hover:text-green-400 transition-colors" data-id="element-487">
              View all notifications
            </button>
          </div>
        </div>
      </div>
    </div>;
};
interface NotificationItemProps {
  icon: React.ReactNode;
  title: string;
  message: string;
  time: string;
  color: string;
}
const NotificationItem = ({
  icon,
  title,
  message,
  time,
  color
}: NotificationItemProps) => <div className="p-4 border-b border-white/5 hover:bg-white/5 transition-colors cursor-pointer" data-id="element-488">
    <div className="flex" data-id="element-489">
      <div className={`${color} rounded-full p-2 mr-3`} data-id="element-490">{icon}</div>
      <div className="flex-1" data-id="element-491">
        <div className="font-medium" data-id="element-492">{title}</div>
        <div className="text-sm text-gray-300" data-id="element-493">{message}</div>
        <div className="text-xs text-gray-400 mt-1" data-id="element-494">{time}</div>
      </div>
    </div>
  </div>;